<template>
  <div>
    <h2>Logout</h2>
    <div class="empty" v-if="loading">
      <div class="empty-icon">
        <i class="icon icon-4x icon-people"></i>
      </div>
      <p class="empty-title h5">We're logging out you user</p>
      <p class="empty-subtitle">Please wait for a moment...</p>
    </div>
  </div>
</template>

<script>
import fb from "@/firebase";

export default {
  data() {
    return {
      loading: true
    };
  },
  computed: {},
  created() {},
  watch: {},
  mounted: function() {
    this.$store.dispatch("clearUserData");
    setTimeout(() => {
      fb.auth.signOut().then(() => {
        this.loading = false;
        this.$router.push({ name: "login" });
      });
    }, 1000);
    console.log("logout");
  },
  methods: {}
};
</script>
